 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		226: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"1a4fc3c","1":"b36874f","2":"ea33955","3":"304c036","4":"a0d3df3","5":"6e9aa7d","6":"1431a33","7":"eea1076","8":"600c36e","9":"f2eb43d","10":"b17279e","11":"6b5f67a","12":"f2eee61","13":"283af99","14":"5eeecac","15":"6540f89","16":"1540744","17":"4816d68","18":"b82de72","19":"0846dbe","20":"100cc7a","21":"b8ba0e7","22":"6adc24b","23":"d093d49","24":"0604303","25":"b8e31d0","26":"feb5773","27":"44ae226","28":"f05ae9e","29":"cee50ec","30":"789d28e","31":"43ea3a1","32":"43df235","33":"8f57722","34":"7125cd7","35":"e171222","36":"9442b82","37":"91694cb","38":"3b10cb9","39":"4b96bec","40":"e24d1e8","41":"86a0cc6","42":"6c8a89b","43":"d9d0d55","44":"69cdd72","45":"877fde3","46":"90a813b","47":"4226db2","48":"0b146d2","49":"beb3420","50":"3badd22","51":"4d57f72","52":"3051d5d","53":"8888168","54":"07dd2bb","55":"10f1fc6","56":"17ccaaa","57":"728d2de","58":"e7eda3c","59":"82b13f1","60":"c6b3ffc","61":"c82d489","62":"a391567","63":"2038853","64":"81342d1","65":"ba79928","66":"d2ca70c","67":"c147a05","68":"e78b99e","69":"13ab282","70":"5537f54","71":"9806cca","72":"f3c532d","73":"f7a6cd5","74":"0e43a01","75":"06857df","76":"436076f","77":"36aa34c","78":"cb995e6","79":"951d7f1","80":"8cd5587","81":"503b370","82":"e0954eb","83":"6c14a86","84":"d51bd1b","85":"44698cb","86":"c64fa2a","87":"687f4e7","88":"0ce94cc","89":"10de8c8","90":"541ef87","91":"55c40d4","92":"075cc14","93":"e0354f2","94":"1d5d9d3","95":"952f047","96":"5438b4d","97":"274c198","98":"7c94e81","99":"196e854","100":"10a198b","101":"0d6c521","102":"fac7cfe","103":"381b87a","104":"dcd99a3","105":"3c58c71","106":"19e5239","107":"5995c76","108":"ac3fa18","109":"b6123ff","110":"b9d41eb","111":"c49d3c1","112":"e059eb6","115":"53808a8","116":"d14b343","117":"3218e3b","118":"e87d5a3","119":"8825c96","120":"318d223","121":"aa02b06","122":"d0b9822","123":"2574d79","124":"7acb8d5","125":"a106b85","126":"800bd13","127":"03fa0fb","128":"5e7d1bf","129":"c689609","130":"86f216d","131":"fc11cd4","132":"f235cdc","133":"68c70d8","134":"7023fd9","135":"c592e29","136":"e5ebf8d","137":"f48ebf3","138":"00eca6a","139":"110efec","140":"ae877b2","141":"d6449d9","142":"28c6a8d","143":"e7d5708","144":"e57503e","145":"03e2c85","146":"3f0d894","147":"c27c948","148":"5ca016c","149":"94d1d59","150":"17922b6","151":"db7fa72","152":"ee79d72","153":"d72fa9b","154":"05589d9","155":"60bc5df","156":"d520dac","157":"c8d34fa","158":"92ff1c3","159":"7e34f3a","160":"2539097","161":"9a92d36","162":"89778d9","163":"1f53dd5","164":"2cff357","165":"d835f13","166":"b9f1b11","167":"524c149","168":"1508283","169":"92b6864","170":"41f60e0","171":"cd324aa","172":"f396533","173":"92d9f03","174":"c39530e","175":"74e9b14","176":"68f2779","177":"127f2ad","178":"1aa3ed5","179":"1b178fd","180":"f9895de","181":"f026a8c","182":"8cd09d2","183":"a164f58","184":"5f198fc","185":"77db6fa","186":"6a18ca5","187":"d37112b","188":"e671654","189":"5df7ab8","190":"a88cc80","191":"334384a","192":"412c142","193":"2fb79e4","194":"3223b17","195":"e8d9e91","196":"faea12e","197":"f204c48","198":"76dc92f","199":"094159e","200":"1c7934b","201":"e2b4d7e","202":"dedf886","203":"b6c74b5","204":"cc591e1","205":"cab349b","206":"f6ebf4f","207":"a30f8b8","208":"9c8ef9d","209":"4dd0a9f","210":"23781ea","211":"c01f9a5","212":"40ecdb9","213":"2f725b1","214":"22eaed5","215":"e8ba08d","216":"12b784a","217":"035f976","218":"c40ad3d","219":"865dc36","220":"5505a52","221":"db226fb","222":"545371c","223":"3c03809","224":"97171ac","225":"d6af556","228":"d418b49","229":"2bab556","230":"89efa0b","231":"3d8cfc6","232":"e98086c","233":"b33ff52","234":"c8a3270","235":"9d33fe6","236":"8861f0b","237":"731abae","238":"0ec4310","239":"ae6c54d","240":"9806354","241":"7caed84","242":"801ee6d","243":"e4dd0b8","244":"ab4aaee","245":"224702e","246":"114872a","247":"98ca646","248":"afcc3a0","249":"c6fc49f","250":"1b7b846","251":"7d65134","252":"762c9f8","253":"8ea9b00","254":"38bd8fd","255":"cbcb7d8","256":"8effdc7","257":"3a666db","258":"05241dd","259":"3421cca","260":"057d52b","261":"9339f86","262":"61bf7db","263":"439255c","264":"d794fee","265":"6871ac1","266":"e407f48","267":"cd8830b","268":"495ac9b","269":"a49f243","270":"0ed72d4","271":"59be9b9","272":"8d7cc33","273":"6b8d9f3","274":"958b346","275":"a2ab4ae","276":"44b2522","277":"13bb062","278":"153b115","279":"77b3f38","280":"247a563","281":"a7863be","282":"4419360","283":"eeb55c4","284":"72e126a","285":"58c0f46","286":"32a636c","287":"10ff0fe","288":"8ef68a0","289":"aef6957","290":"53e04f6","291":"9cb657d","292":"3793150","293":"402e765","294":"288038e","295":"b180116","296":"c51ccde","297":"e8355df","298":"c6e43d1","299":"c41ada5","300":"5e12cd7","301":"6cc010a","302":"1a0f83a","303":"b143fdb","304":"01e501d","305":"c789f9f","306":"0272f67","307":"3eab8cf","308":"e33c4da","309":"d205255","310":"7f78e14","311":"7c972c8","312":"b2f3916","313":"5596897","314":"a943bbe","315":"760d929","316":"b6e7fc4","317":"6e595b0","318":"9a3aef4","319":"201b6f8","320":"af60103","321":"7e50940","322":"59b4278","323":"c18bfa8","324":"15953ec","325":"60840e8","326":"4b6fa5b","327":"50f1dac","328":"2dc7142","329":"9586fff","330":"28f7c89","331":"7c91dd9","332":"b2a4c83","333":"6f48e46","334":"d68be8c","335":"8f502df","336":"b6d416e","337":"96009cc","338":"3dae6fa","339":"659967e","340":"f2d3774"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d2kaq61j235tiz.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
